// extracted by mini-css-extract-plugin
export default {"leaveContainer":"LeaveSlot_leaveContainer__yY3NT"};